<template>
  <div class="home">
    <Swipe :autoplay="3000" lazy-render indicator-color="white" touchable>
      <SwipeItem v-for="ad in ads" :key="ad.id" @click="jump(ad.url)">
        <div>
          <img :src="ad.src" style="width: 100%; height: auto;" />
        </div>
      </SwipeItem>
    </Swipe>
    <!-- <Form style="margin-top: 16px;">
      <CellGroup 
        inset 
        style="display: flex; justify-content: center; align-items: center; border: 1px solid #e8e8e8; border-radius: 8px;">
        <Icon name="calendar-o" size="26" />
        <input 
          type="text" 
          v-model="dateRange[0]"
          placeholder="开始日期" 
          readonly
          @click="showCalendar(0)"
          style="text-align: center; width: 40%; border: none;"
        />
        <p>To</p>
        <input 
          type="text" 
          v-model="dateRange[1]"
          placeholder="结束日期" 
          readonly
          @click="showCalendar(1)"
          style="text-align: center; width: 40%; border: none;"
        />
      </CellGroup>
      <div style="margin: 16px;">
        <Button 
          type="primary" 
          block 
          style="border-radius: 8px;"
          @click="handleSearch">查询</Button>
      </div>
    </Form> -->
    <!-- <Calendar 
      :show="show"
      type="single"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="handleCalendarConfirm"
      @close-on-click-overlay="() => { show = false }"
      @close="() => { show = false }"
    /> -->
    <div class="list" style="">
      <List
        v-if="salaryList.length > 0"
        :loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadMore">
        <div class="list-card" v-for="(item) in salaryList" :key="item.salaryId">
          <Cell 
            :title="item.salaryName" 
            titleStyle="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; fonst-size: 16px;" 
            :label="item.createTime" 
            :border="false"
            style="align-items: center;">
          </Cell>
          
          <div style="padding: 0 16px; font-size: 14px; display: flex; align-items: center; justify-content: space-between;">
            
            <div style="display: flex; align-items: center;">
              <Image :src="avatar(item.avatar)" round mode="widthFix" style="width: 30px; height: 30px; border-radius: 20px; margin-right: 16px;" />
              <div style="font-size: 13px; color: #333;">{{item.author}}</div>
            </div>
            <div>
              <Button type="primary" size="small" @click="querySalary(item.salaryId)">
                查询工资
              </Button>
            </div>
          </div>
          <div v-if="item.remark" style="padding: 16px 16px 0 16px; font-size: 14px; color: #eeeeee;">
            Tips: {{ item.remark }}
          </div>
        </div>
      </List>
    </div>
    <BackTop offset="500" />
  </div>
</template>

<script setup>
import { ref, inject, onBeforeMount } from 'vue'
import { Cell, List, Swipe, SwipeItem, BackTop, Image, Button } from 'vant';
import ad1 from '@/assets/images/ad1.png'
import ad2 from '@/assets/images/ad2.png'
import { useRouter } from 'vue-router'

const dateRange = ref([])
// const currentPos = ref(0)
// const show = ref(false)
// const minDate = ref(new Date(2021, 1, 1))
// const maxDate = ref(new Date(2023, 12, 31))
const salaryList = ref([])
const queryParams = ref({
  pageNum: 1,
  pageSize: 10
})
const loading = ref(false)
const finished = ref(false)
const $axios = inject('$axios')
const loadMore = async () => {
  console.log('loadMore')
  console.log(!loading.value)
  if (!loading.value) {
    loading.value = true
    
    try {
      queryParams.value.pageNum++
      await getSalaryList()
    } finally {
      loading.value = false
    }

  }
}
const ads = ref([
  {
    id: 1,
    src: ad1,
    url: ''
  },
  {
    id: 2,
    src: ad2,
    url: ''
  }
])
const router = useRouter()
// const route = useRoute()

onBeforeMount(() => {
  getSalaryList()
})

async function getSalaryList() {
  let list
  try {
    let params = addDateRange(queryParams.value, dateRange.value);
    let url = '/prod-api/lt/salary/list?' + tansParams(params);
    let res = await $axios.get(url);
    if (res.data.code === 200) {
      list = res.data;
      console.log(list);
    }
  } catch (err) {
    console.log(err);
  }
  salaryList.value.push(...list.rows)

  if (list.rows.length < 10) {
    finished.value = true
  }
}

function avatar(avatar) {
  return avatar? '/prod-api/' + avatar : ''
}

// function handleSearch() {
//   queryParams.value.pageNum = 1
//   salaryList.value = []
//   finished.value = false
//   getSalaryList()
// }

function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof (propName) === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
}

function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

// function showCalendar(pos) {
//   currentPos.value = pos
//   show.value = true
// }

// function handleCalendarConfirm(val) {
//   dateRange.value[currentPos.value] = formatDate(val)
//   console.log(dateRange.value)
//   show.value = false
// }

// function formatDate(date) {
//   const year = date.getFullYear()
//   const month = date.getMonth() + 1
//   const day = date.getDate()
//   return `${year}-${month}-${day}`
// }

function jump(url) {
  window.location.href = url
}

function querySalary(salaryId) {
  // jump('/salary/detail?salaryId=' + salaryId)
  console.log(salaryId)
  router.push({
    path: '/login',
    query: {
      salaryId: salaryId
    }
  })
}

</script>

<style scoped>
.home {
  background: #eeeeee;
}
.list-card {
  background-color: #ffffff;
  margin: 10px;
  padding-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
}
</style>
